import React from "react"
import { Link } from "gatsby"
import SideBarMenu from "../sidebar/sidebar"
import Sticky from "react-sticky-el"
import styl from "./header.module.css"
import logo from "../../images/logo.png"
import search from "../../images/favicon.png"

const Header = () => (
  <header>
    <Sticky
      className={styl.stickyWrapper}
      stickyClassName={styl.isSticky}
      stickyStyle={{ transform: "unset", zIndex: "2" }}
    >
      <div className={`header ${styl.header}`}>
        <div class="container">
          <div class="row justify-content-between align-items-center">
            <div class="col p-0">
              <div class="header-logo">
                <Link to="/">
                  <img src={logo} />
                </Link>
              </div>
            </div>

            <div
              class="col-4 d-flex justify-content-end"
              style={{ position: "relative" }}
            >
              <div class="text-right phone-cta">
                <a
                  href="https://www.facebook.com/toddasana.co/"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    position: "relative",
                    top: "-11.5px",
                    padding: "40px 20px 21px 20px",
                    color: "#fff",
                    backgroundColor: "#0c88ef",
                    // right: "-7em;",
                    zIndex: "2",
                  }}
                >
                  <i class="fa fa-facebook-f" />
                </a>
              </div>
              <div class="text-right phone-cta linkedin-cta">
                <a
                  href="https://www.linkedin.com/in/toddwheeler/"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    backgroundColor: "#000",
                    position: "relative",
                    top: "-11.5px",
                    padding: "40px 20px 21px 20px",
                    color: "#fff",
                    backgroundColor: "#0077b5",
                    // right: "-4.1em",
                    zIndex: "2",
                  }}
                >
                  <i class="fa fa-linkedin" />
                </a>
              </div>
              <div class="text-right phone-cta">
                <Link
                  to="/contact-us"
                  style={{
                    position: "relative",
                    top: "-14px",
                    padding: "40px 20px 21px 20px",
                    color: "#fff",
                    backgroundColor: "#1a2275",
                    zIndex: "1",
                    fontFamily: `${"Oswald"}, "sans-serif"`,
                  }}
                >
                  {/* <i class="fa fa-phone mr-2"></i>303.883.8001 */}
                  Contact Us
                </Link>
              </div>
              <div class="text-right phone-cta mobile-dnone">
                <Link
                  to="/interviews-webinars"
                  style={{
                    position: "relative",
                    top: "-14px",
                    padding: "40px 20px 21px 20px",
                    color: "#fff",
                    backgroundColor: "#0c88ef",
                    zIndex: "1",
                    fontFamily: `${"Oswald"}, "sans-serif"`,
                  }}
                >
                  {/* <i class="fa fa-phone mr-2"></i>303.883.8001 */}
                  Interviews/Webinars/Articles
                </Link>
              </div>
            </div>

            <div class="col-1" style={{ maxWidth: "6.333%" }}>
              <div class="text-right">
                <SideBarMenu />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Sticky>
  </header>
)

export default Header
